export default function BusinessSolutionsDetailArticleData() {
  return {
    items: [
      { 
        title: "Buy/Sell Case Study",
        image : "/product-landing/busi/buy-sell-crop.png",
        mobileImage: "/product-landing/busi/buy-sell-crop-small.png",
        backgroundContrast: false,
        anchor: "buysell",
        section: [
          {
            title: "The Problem",
            paragraphs: [
              "A construction company was founded many years ago by two partners. Since that time, they have added additional contractors to the company. The partners who started the company begin to worry about what would happen to the company if something happened to either of them."
            ]
          },
          {
            title: "The Solution",
            paragraphs: [
              "The partners met with their financial advisor who suggested a buy-sell agreement. This type of arrangement would protect the company and the families of the owners. With a buy-sell agreement, funded with life insurance, provides the partners with the reassurance that their company would be taken care of if either of them were to pass away."
            ]
          }
        ],
        callToAction: [
          {
            buttonTitle: "SEE RATES",
            buttonLight: false,
            productType: "term",
            href: null
          },
          {
            buttonTitle: "CONTACT A SPECIALIST",
            buttonLight: true,
            href: "/select-appointment"
          },
        ],
      },
      { 
        title: "Key Person Case Study",
        image : "/product-landing/busi/key-person-crop.png",
        mobileImage: "/product-landing/busi/key-person-crop-small.png",
        backgroundContrast: true,
        anchor: "keyperson",
        section: [
          {
            title: "The Problem",
            paragraphs: [
              "Sasha owns a well-known bakery in New York City. The bakery has a famous baker that produces delicious baked goods, and the bakery depends on this baker. Sasha has come to the conclusion that the bakery would be in jeopardy if something were to happen to the baker.",
              ]
          },
          {
            title: "The Solution",
            paragraphs: [
              "Sasha meets with a financial advisor to discuss different solutions for the bakery. ",
              "Sasha purchases key person life insurance to make sure her business would still be successful if something were to happen with the baker.",
              "$500,000 death benefit based on the size of the bakery and the annual income.",
              "Since the bakery is relatively new, she decided on a 30-year term policy and will use policy review each couple years to see if the policy needs updating."
            ]
          }
        ],
        callToAction: [
          {
            buttonTitle: "SEE RATES",
            buttonLight: false,
            productType: "term",
            href: null
          },
          {
            buttonTitle: "CONTACT A SPECIALIST",
            buttonLight: true,
            href: "/select-appointment"
          },
        ],
      },
      { 
        title: "Small Business Loan Case Study",
        image : "/product-landing/busi/small-business-crop.png",
        mobileImage: "/product-landing/busi/small-business-crop-small.png",
        backgroundContrast: false,
        anchor: "smallbusiness",
        section: [
          {
            title: "The Problem",
            paragraphs: [
              "Greg opened a restaurant a few years ago where he started in a small location. The restaurant has become very popular and has gained attention from customers all over the area and surrounding towns. Greg has decided to open another location due to the demand from all the customers."
            ]
          },
          {
            title: "The Solution",
            paragraphs: [
              "Greg received an SBA loan of $300,000. This loan will give Greg the funds to open the new location of his restaurant and fulfill the needs of all the customers. Greg will need insurance protection on this loan to safeguard his restaurant business in case something were to happen."
            ]
          }
        ],
        callToAction: [
          {
            buttonTitle: "SEE RATES",
            buttonLight: false,
            productType: "americo",
            href: null
          },
          {
            buttonTitle: "CONTACT A SPECIALIST",
            buttonLight: true,
            href: "/select-appointment"
          },
        ],
      },
    ]
  };
}
